// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module--container--bKR9C","slider":"style-module--slider--3gFkT","sliderDots":"style-module--sliderDots--2jTyF"};